export default __webpack_public_path__ + "static/media/trash1.460435e8.svg";